module.exports = "<div #baChartistChart class=\"ba-chartist-chart {{baChartistChartClass || ''}}\"></div>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/theme/components/baChartistChart/baChartistChart.html
// module id = 615
// module chunks = 9